var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationsMuteNone = function SvgNotificationsMuteNone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:volume-mute"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.717 4.04396C7.80171 4.08024 7.8732 4.13702 7.92326 4.20778C7.97332 4.27855 7.99991 4.36042 8 4.44402V11.5561C7.99987 11.6398 7.97319 11.7217 7.92303 11.7924C7.87288 11.8632 7.80128 11.92 7.71647 11.9562C7.63166 11.9924 7.53708 12.0066 7.4436 11.9972C7.35011 11.9877 7.26152 11.955 7.188 11.9028L4.825 10.2226H2.5C2.36739 10.2226 2.24021 10.1758 2.14645 10.0924C2.05268 10.0091 2 9.89599 2 9.7781V6.22204C2 6.10415 2.05268 5.99109 2.14645 5.90773C2.24021 5.82437 2.36739 5.77754 2.5 5.77754H4.825L7.188 4.0973C7.26157 4.04502 7.35026 4.01227 7.44385 4.00283C7.53744 3.9934 7.63212 4.00765 7.717 4.04396Z",
    fill: "#C5C9CB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 5.14286C12 5.14286 12.8182 6.21429 12.8182 8C12.8182 9.78571 12 10.8571 12 10.8571M13.6364 3C13.6364 3 15 4.78571 15 8C15 11.2143 13.6364 13 13.6364 13",
    stroke: "#C5C9CB",
    strokeWidth: 1.16883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.1228 6C10.1228 6 10.6955 6.7499 10.6955 7.99972C10.6955 9.24955 10.1228 9.99944 10.1228 9.99944",
    stroke: "#C5C9CB",
    strokeWidth: 1.17,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationsMuteNone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "notifications_mute_none.88b0d683c0f896d1133bd32c3b31536a.svg";